import React from "react";
import Svg from './Svg';
import constants from "../constants";

/**
 * @type {Array} t
 */
let t = constants.countriesAdvanced;

const LanguageSelector = (props) => {
    let selectorRef = React.createRef();

    const onClick = (e, item) => {
        if (item.translationMissingPage) {
            e.preventDefault();
            window.location.href = item.value;
        }
    }

    let selected = t.filter(x => x.selected);

    if (!selected || !selected.length) return null;
    selected = selected[0];

    const closeDropdown = () => {
        if(!selectorRef.current) return;
        selectorRef.current.classList.remove('language-selector__dropdown--active');
    };

    const toggle = () => {
        if(selectorRef.current.className.indexOf('language-selector__dropdown--active') === -1){
            selectorRef.current.classList.add('language-selector__dropdown--active');
        }
        else {
            selectorRef.current.classList.remove('language-selector__dropdown--active');
        }
    };
    
    const onKeyUp = (e) => {
        if(e.keyCode === 32 || e.keyCode === 13) {
            e.preventDefault();
            toggle();
        }
    }

    const handleBlur = (e) => {
        const currentTarget = e.currentTarget;
        setTimeout(() => {
            if (!currentTarget.contains(document.activeElement)) {
                closeDropdown();
            }
        }, 0);
    };


    return (
        <div 
            className="language-selector__wrapper js-language-selector"
            tabIndex="0"
            onKeyUp={onKeyUp}
            onBlur={handleBlur}
        >
            <div>
                {props.currentAsIcon ?
                    <div className="language-selector__icon-wrapper" onClick={toggle}>
                        <img className="icon" src={selected.icon} alt={selected.alt} />
                        <div className="language-selector__icon-label">{selected.text}</div>
                    </div>
                    :
                    <div className="language-selector__current-wrapper" onClick={toggle}>
                        <span>{selected.text}</span>
                        <Svg icon="arrow-right" />
                    </div>
                }
            </div>

            <ul className="language-selector__dropdown js-language-dropdown" ref={selectorRef}>
                {t.map((item, index) =>
                    <li key={`figure${index}`}>
                        <a href={!item.translationMissingPage ? item.value : undefined} onClick={(e) => onClick(e, item)} className="language-selector__link">
                            <img className="icon" src={item.icon} alt={item.alt} />
                            <span>{item.text}</span>
                        </a>
                    </li>
                )}
            </ul>
        </div>
    );
};

export default LanguageSelector;